export default __webpack_public_path__ + "static/media/anmalan-till-modersmalsundervisning_grundskolan.b1ff2f7e.pdf";